import React from "react";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel/InputLabel";
import Select from "@mui/material/Select/Select";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import FormHelperText from "@mui/material/FormHelperText";

const StepApartment = props => {
    const {homes, isEditMode, formik} = props;

    // generate plainMenu for selection
    const menu = homes.reduce((acc, h) => {
        const home = {
            isGroupHeader: true,
            key: `h-${h.id}`,
            id: h.id,
            name: h.name
        };
        const apartments = h.apartments.map(a => {
            return {
                isGroupHeader: false,
                key: `a-${a.id}`,
                id: a.id,
                name: a.name
            }
        });

        const plainList = [home].concat(apartments);
        return acc.concat(plainList);
    }, []);

    const getSelectedApartmentName = () => {
        const apartmentId = formik.values.apartmentId;
        for (let home of homes) {
            for (let apartment of home["apartments"]) {
                if (apartment.id === apartmentId) {
                    return `${home["name"]} - ${apartment["name"]}`;
                }
            }
        }
        return null;
    };

    return (
        <React.Fragment>
            <Typography variant="h6">
                Struttura
            </Typography>

            <Box sx={{my: 4}}>
                <Grid container>
                    <Grid item xs={12}>
                        {
                            isEditMode ?
                                <Typography>
                                    {getSelectedApartmentName()}
                                </Typography>
                                :
                                <FormControl variant="outlined"
                                             fullWidth
                                             error={formik.touched.apartmentId && Boolean(formik.errors.apartmentId)}>
                                    <InputLabel id="select-apartment-label">Appartamento</InputLabel>
                                    <Select labelId="select-apartment-label"
                                            label="Appartamento"
                                            id="apartmentId"
                                            name="apartmentId"
                                            value={formik.values.apartmentId}
                                            onChange={formik.handleChange}>
                                        <MenuItem value=""><em>Nessuno</em></MenuItem>
                                        {
                                            menu.map(i => {
                                                if (i.isGroupHeader) {
                                                    return <ListSubheader key={i.key} value="">{i.name}</ListSubheader>
                                                } else {
                                                    return <MenuItem key={i.key} value={i.id}>{i.name}</MenuItem>
                                                }
                                            })
                                        }
                                    </Select>
                                    {
                                        formik.touched.apartmentId && formik.errors.apartmentId &&
                                        <FormHelperText>{formik.errors.apartmentId}</FormHelperText>
                                    }
                                </FormControl>
                        }

                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    )
};

StepApartment.propTypes = {
    homes: PropTypes.arrayOf(PropTypes.object).isRequired,
    isEditMode: PropTypes.bool.isRequired,
    formik: PropTypes.object.isRequired
};

export default StepApartment;